import React, { Component } from "react"
import { Button } from 'antd'
import SvgIcon from 'src/components/SvgIcon'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { getCurrentPageUrlInfo } from 'src/utils/helpers'
import { isNavBottomVisible } from 'src/utils/features'

import './NavBottom.less'

class NavBottom extends Component {
  handleClickHome = () => {
    const { history, setCurrentlyOpenFeature, openSidebar } = this.props 

    if (typeof setCurrentlyOpenFeature === 'function') {
      setCurrentlyOpenFeature('')
    }

    if (typeof openSidebar === 'function') {
      openSidebar()
    }

    if (history) {
      history.push('/')
      return true
    }
  }

  handleClickChat = () => {
    const { history, setCurrentlyOpenFeature, closeSidebar } = this.props

    if (typeof setCurrentlyOpenFeature === 'function') {
      setCurrentlyOpenFeature('chat')
    }

    if (typeof closeSidebar === 'function') {
      closeSidebar()
    }

    if (history) {
      history.push('/chat')
      return true
    }
  }
  
  render() {
    const {
      location,
      chatUnreadCount,
      isChatOnlyFeature,
      features,
      isAfterHours,
      isChatEmpty,
      chatOptions,
      areAppActionsDisabled,
    } = this.props

    if (!isNavBottomVisible(features, chatOptions, isAfterHours, isChatEmpty, isChatOnlyFeature)) {
      return ''
    }

    const currentPageUrl = getCurrentPageUrlInfo(location, 'url')

    const activeTab = currentPageUrl && currentPageUrl === '/chat' ? 'chat' : 'home'

    return (
      <div className="c-layout-nav-bottom">
        <Button.Group>
          <Button
            disabled={!!areAppActionsDisabled}
            className={'button--home active-' + (activeTab === 'home' ? 'yes' : 'no')}
            onClick={this.handleClickHome}
          >
            <SvgIcon type={activeTab === 'chat' ? 'Home_On' : 'Home_Off'} size={'md'} />
            <FormattedMessage
              id="app.homeTab"
              defaultMessage="Home"
            />
          </Button>
          <Button
            disabled={!!areAppActionsDisabled}
            className={'button--chat active-' + (activeTab === 'chat' ? 'yes' : 'no')}
            onClick={this.handleClickChat}
          >
            <SvgIcon type={activeTab === 'chat' ? 'Chat_On' : 'Chat_Off'} size={'md'} />
            <FormattedMessage
              id="app.chatTab"
              defaultMessage="Chat"
            />
            {chatUnreadCount > 0 && <i>{chatUnreadCount}</i>}
          </Button>
        </Button.Group>
      </div>
    )
  }
}

export default withRouter(injectIntl(NavBottom))